// src/routes.js
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import App from './components/App';


const Routes = (props) => (
  <BrowserRouter {...props}>
    <Route path="/" render={props => <App {...props} />} />
  </BrowserRouter>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.jsx